"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEscapeClasses = void 0;

var react_1 = require("react");
/**
 * useEscapeClasses is helper for creating stable escape hatch classes. It takes
 * a configuration object and returns a memoized function that generates
 * classes. You can generate three types of classes with this helper:
 * 1. **Root** classes are attached to the root wrapper of the component.
 * Generate them with no arguments `makeClasses()`. `className` is attached to
 * the root as well.
 * 2. **Module** classes are attached to inner components. Generate them with
 * passing the module name `makeClasses('name')`.
 * 3. **Scope** modifiers are attached to both root and inner components, if the
 * consumer wants to add a scope.
 *
 * _Note: Inspired by BEM._
 * @see http://getbem.com/introduction/
 */


var useEscapeClasses = function useEscapeClasses(_a) {
  var block = _a.block,
      className = _a.className,
      __UIScope = _a.__UIScope;
  var makeClasses = (0, react_1.useMemo)(function () {
    return function (module) {
      var classes = ''; // (1) Root classes

      if (!module) {
        classes = classes.concat("hpn-".concat(block)); // styled-components uses className to apply styles when wrapped in styled

        if (className) {
          classes = classes.concat(" ".concat(className));
        } // (3) Modifiers


        if (__UIScope) {
          classes = classes.concat(" hpn-".concat(block, "--").concat(__UIScope));
        }
      } else {
        // (2) Module classes
        classes = classes.concat("hpn-".concat(block, "__").concat(module)); // (3) Modifiers

        if (__UIScope) {
          classes = classes.concat(" hpn-".concat(block, "__").concat(module, "--").concat(__UIScope));
        }
      }

      return classes;
    };
  }, [block, className, __UIScope]);
  var rootClasses = (0, react_1.useMemo)(function () {
    return makeClasses();
  }, [makeClasses]);
  return {
    makeClasses: makeClasses,
    rootClasses: rootClasses
  };
};

exports.useEscapeClasses = useEscapeClasses;